/**
 * Keeps the transcript pinned to its newest turn without moving anything outside the panel.
 * PLA-8844.
 *
 * `scrollIntoView` was the obvious call and is the wrong one: it scrolls EVERY scrollable ancestor
 * of the element it is given, and the panel is an in-flow sticky column of the app's has-sider row
 * (`OrbitShell`), so the document is one of those ancestors. Asking a question therefore scrolled
 * the dashboard beside the panel, which carried another card across the card-in-view reference line
 * (`Intelligence/filters/useCardInView`) and raised the context-change card over a scroll the user
 * never made.
 */

/**
 * Marks the one element the panel scrolls. Read with `closest`, so the transcript does not have to
 * be handed a ref across the `children` boundary `OrbitSidebar` puts between them.
 */
export const ORBIT_SCROLL_CONTAINER_ATTR = 'data-orbit-scroll-container';

export const orbitScrollContainerOf = (element: Element | null | undefined): HTMLElement | null =>
  element?.closest<HTMLElement>(`[${ORBIT_SCROLL_CONTAINER_ATTR}]`) ?? null;

/**
 * The bottom of the panel's own scroll container, reached by assignment rather than through any
 * scroll API that takes an element: an over-large `scrollTop` is clamped by the browser, and
 * nothing outside the container can move.
 */
export const scrollOrbitThreadToEnd = (element: Element | null | undefined): void => {
  const container = orbitScrollContainerOf(element);

  if (container === null) {
    return;
  }

  container.scrollTop = container.scrollHeight;
};
